<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">{{ data.headline }}</div>

    <div [formGroup]="tier" class="modal-body cl-form">
      <div>
        <label class="form-label" for="drm_streamtype">Stream type</label>
        <select class="form-select it-drm-field-streamtype" formControlName="streamtype" id="drm_streamtype">
          @for (t of data.streamTypes; track t) {
            <option [ngValue]="t">{{ t }}</option>
          }
        </select>
        <p class="valid-feedback d-block">The DRM key tier that renditions in this width range are encrypted with. Declare each tier once, in the order {{ data.streamTypes.join(', ') }}.</p>
      </div>

      <div class="cl-spacing-small">
        <label class="form-label" for="drm_max_width">Max width (inclusive)</label>
        @if (data.isLast) {
          <input class="it-drm-field-max-width" disabled id="drm_max_width" placeholder="unbounded" type="text">
          <p class="valid-feedback d-block">The last tier covers every width above the one before it, so it has no upper bound.</p>
        } @else {
          <input [class.invalid]="showErrors && tier.get('max_width').invalid" class="it-drm-field-max-width" formControlName="max_width" id="drm_max_width" min="1" step="1" type="number">
          @if (showErrors && tier.get('max_width').errors?.min) {
            <p class="invalid-feedback d-block">Must be at least 1.</p>
          } @else {
            <p class="valid-feedback d-block">Renditions up to and including this width use this tier's key. It must be wider than the tier before it.</p>
          }
        }
      </div>

      @if (showErrors) {
        <app-drm-errors [errors]="data.setErrors()" />
      }
    </div>

    <div class="modal-footer">
      <span class="modal-footer-left">
        <button (click)="dialogRef.close(false)" class="btn cl-color-secondary it-cancel" type="button">
          <span>Cancel</span>
        </button>
      </span>
      <span class="modal-footer-center"></span>
      <span class="modal-footer-right">
        <button (click)="dialogRef.close(true)" [disabled]="tier.invalid" class="btn cl-color-primary it-ok" type="button">
          <span>{{ data.actionName }}</span>
        </button>
      </span>
    </div>
  </div>
</div>
